import type { FC } from 'react';
import { useEffect } from 'react';

import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import { Card } from 'src/app/components/Elements/Card';
import StandardPage from 'src/app/components/Elements/Page/Standard';
import Spinner from 'src/app/components/Elements/Spinner';
import { StyledSpinnerContainer } from 'src/app/components/Pages/GetStarted/styles';

import type { PropsFromRedux } from './container';
import { MedGuideContainer } from './styles';

export const BrandedMedicationGuideRenderer: FC<PropsFromRedux> = ({
  ndc,
  dispatchFetchMedicationGuides,
  sanitizedMedGuideHtml,
  hasMedicationGuidesLoaded,
  dispatchSegmentTrack,
}) => {
  useEffect(() => {
    dispatchSegmentTrack(UNIFIED.viewMedicationGuide, { source: 'Medication Details Bottom Link' });
  }, [dispatchSegmentTrack]);

  useEffect(() => {
    if (ndc && !sanitizedMedGuideHtml) dispatchFetchMedicationGuides(ndc);
  }, [dispatchFetchMedicationGuides, ndc, sanitizedMedGuideHtml]);

  if (!hasMedicationGuidesLoaded)
    return (
      <StyledSpinnerContainer>
        <Spinner centered={false} />
      </StyledSpinnerContainer>
    );

  return (
    <StandardPage>
      <Card>
        <MedGuideContainer dangerouslySetInnerHTML={{ __html: sanitizedMedGuideHtml }} />
      </Card>
    </StandardPage>
  );
};
